import { SpAlert } from '../../../../../../components/sp-alert/sp-alert.model';

export class Controller {

    /** @ngInject */
    constructor(FederateSsoResource) {
        this.FederateSsoResource = FederateSsoResource;
    }

    $onInit() {
        this.credentials = {username: '', password: ''};
    }

    save() {

        const {companyId, appId} = this.resolve;

        this.isSaving = true;
        this.FederateSsoResource
            .federateSso(companyId, appId, this.credentials)
            .then(() => {
                this.isSaved = true;
                const key = 'company.manage-application.integration-developers.configure-sso.saved';
                this.spAlert = new SpAlert('success', key, {}, false);
            })
            .catch(() => {
                const key = 'company.manage-application.integration-developers.configure-sso.failed';
                this.spAlert = new SpAlert('danger', key);
            })
            .finally(() => this.isSaving = false)
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/integration-developers/configure-sso/auto-configure-sso/auto-configure-sso.controller.js